import { CommonErrorJsEnv } from "../common_error_js_env";

// RRサーバにリクエストを送る時に設定する、画面によって変わるパラメータ。
export const setRrRequestParams = (R3_COMMON: r3_common, pageOption: any) => {
  R3_COMMON.addPlacementType('error_page.' + pageOption.placementNameCommonError2);
  R3_COMMON.addPlacementType('error_page.' + pageOption.placementNameCommonError3);
}

export const createRrRequestParam = (model: CommonErrorJsEnv) => {
  return {
    isLogin: model.isLogin,
    userId: model.userId,
    userTracking: model.userTracking,
    userSegments: model.userSegments,
    setRrRequestParams: setRrRequestParams,
    pageOption: {
      placementNameCommonError2: model.rrAreaProfileCommonError2.placementName,
      placementNameCommonError3: model.rrAreaProfileCommonError3.placementName,
    }
  };
}
